
import React, { useState } from "react";
import logo from "./assets/logo.png";
import { apiFetch } from "./api";

function ResetPassword({ setPage }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const token = new URLSearchParams(
    window.location.search
  ).get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading || success) return;

    setMessage("");

    if (!token) {
      setMessage("Invalid password reset link.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    if (!strongPasswordRegex.test(newPassword)) {
      setMessage(
        "Password must be 8+ characters and include uppercase, lowercase, number and special character."
      );
      return;
    }

    setLoading(true);

    try {
      const res = await apiFetch("/reset-password", {
        method: "POST",
        body: JSON.stringify({ token, newPassword })
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.error || "Unable to reset password.");
      } else {
        setSuccess(true);
        setNewPassword("");
        setConfirmPassword("");
        setMessage(
          "Password reset successful. You can now log in."
        );

        // Remove the reset token from the browser URL.
        window.history.replaceState(
          {},
          "",
          "/reset-password"
        );
      }
    } catch (err) {
      console.error("Reset password error:", err);
      setMessage("Unable to reset password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    boxSizing: "border-box",
    width: "100%",
    padding: 10,
    margin: "10px 0",
    borderRadius: 6,
    border: "1px solid #ccc"
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#f5f6fa"
    }}>
      <div style={{
        background: "white",
        padding: 30,
        borderRadius: 10,
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        width: 320,
        textAlign: "center"
      }}>
        <h1>Mukbi CRM</h1>

        <img
          src={logo}
          alt="Mukbi CRM"
          style={{ width: 120 }}
        />

        <h2>Reset Password</h2>

        {!success && token && (
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
              style={inputStyle}
            />

            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
              style={inputStyle}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: 10,
                background: "#2c3e50",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: loading ? "wait" : "pointer"
              }}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}

        {!token && !success && (
          <p style={{ color: "#c0392b" }}>
            This password reset link is invalid.
          </p>
        )}

        {message && (
          <p role="status" style={{
            marginTop: 15,
            fontSize: 13,
            color: success ? "#15803d" : "#c0392b"
          }}>
            {message}
          </p>
        )}

        <p
          onClick={() => {
            window.location.replace("/");
          }}
          style={{
            color: "#3498db",
            cursor: "pointer",
            marginTop: 20
          }}
        >
          Back to Login
        </p>
      </div>
    </div>
  );
}

export default ResetPassword;
